<template>
    <div class="toggle-switch-pp">
        <label class="switch">
            <input type="checkbox" v-model="checked" @change="changeValueAction($event.target.checked)" />

            <span class="slider round"></span>

            <div class="text" :class="{ active: checked, inactive: !checked }" v-if="getShowTextValue">
                {{ checked ? 'Sim' : 'Não' }}
            </div>
        </label>
    </div>
</template>

<script>
export default {
    name: 'ToggleSwitchPP',
    props: {
        isChecked: {
            type: Boolean,
            default: false
        },
        showTextValue: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checked: false
        }
    },
    computed: {
        getIsChecked() {
            return this.isChecked
        },
        getShowTextValue() {
            return this.showTextValue
        }
    },
    methods: {
        changeValueAction: function(value) {
            this.$emit('changeValueAction', value)
        }
    },
    mounted() {
        this.checked = this.isChecked
    }
}
</script>

<style scope src="./ToggleSwitchPP-light-theme.css"></style>
<style scope src="./ToggleSwitchPP-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/ui/toggle-switch-pp/ToggleSwitchPP.vue